import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "header-logo",
  class extends Controller {
    static targets = ["logotype", "logo"]
    static values = { threshold: { type: Number, default: 0.5 } }

    connect() {
      this.handleScroll = this.handleScroll.bind(this)
      window.addEventListener("scroll", this.handleScroll, { passive: true })
      this.handleScroll()
    }

    disconnect() {
      window.removeEventListener("scroll", this.handleScroll)
    }

    handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset
      const viewportHeight = window.innerHeight
      const threshold = viewportHeight * this.thresholdValue

      if (scrollY >= threshold) {
        this.showLogo()
      } else {
        this.showLogotype()
      }
    }

    showLogo() {
      if (this.hasLogotypeTarget && this.hasLogoTarget) {
        this.logotypeTarget.classList.add("opacity-0")
        this.logoTarget.classList.remove("opacity-0")
      }
    }

    showLogotype() {
      if (this.hasLogotypeTarget && this.hasLogoTarget) {
        this.logotypeTarget.classList.remove("opacity-0")
        this.logoTarget.classList.add("opacity-0")
      }
    }
  },
)
